export const Colors = {
  cotton_candy: '#FFB2E6',
  heliotrope: '#D972FF',
  purple_x_11: '#8447FF',
  aquamarine: '#8CFFDA',
  beige: '#FFFFE8',
};
